<div class='container'>
    <p>Sorry, the page you are looking for could not be found.</p>
    <button class='next' (click)='navigateToHome()'>return home</button>
</div>
